import { useEffect } from 'react';
import styled from 'styled-components';
import ReceiptLayout from '@/components/common/ReceiptLayout';
import TextButton from '@/components/common/TextButton';
import ProgressBar from '@/components/common/ProgressBar';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { useHistory } from 'react-router';
import { routes } from '@/constant/routes.const';
import { ICON_CHECK_STYLED } from '@repo/assets';
import { BankCallGuide } from '@repo/components';
import { BANK_CALL_GUIDE } from '@repo/constants';

function RefundResult() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { nationality } = useAppSelector((state) => state) as IGlobalState;

  useEffect(() => {
    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: { register: true },
    });
  }, []);

  useEffect(() => {
    const handleBackButton = () => {
      window.history.go(1);
    };
    window.addEventListener('popstate', handleBackButton);
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  return (
    <ReceiptLayout>
      <ProgressBar percent={100} />
      <Wrapper>
        <Img src={ICON_CHECK_STYLED} alt='' />
        <Title>
          {nationality === 'KOR'
            ? '송금정보입력 완료'
            : nationality === 'CHN'
              ? '信息输入完毕'
              : 'Remittance Information Entered'}
        </Title>
        <Description>
          {(nationality === 'CHN' || nationality === 'JPN') && (
            <BankCallGuide
              title={BANK_CALL_GUIDE[nationality].title}
              questionTitle={BANK_CALL_GUIDE[nationality].questionTitle}
              questionText={BANK_CALL_GUIDE[nationality].questionText}
              answerTitle={BANK_CALL_GUIDE[nationality].answerTitle}
              answerText={BANK_CALL_GUIDE[nationality].answerText}
            />
          )}
        </Description>
      </Wrapper>
      <TextButton
        title={
          nationality === 'KOR'
            ? '다음'
            : nationality === 'CHN'
              ? '下一步'
              : 'Next'
        }
        bgColor='#246CF6'
        color='#FFFFFF'
        margin='20px 0 0'
        onClick={() => history.push(routes.home)}
      />
    </ReceiptLayout>
  );
}

export default RefundResult;

const Wrapper = styled.div`
  width: 335px;
  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
    width: 100%;
  }
`;

const Img = styled.img`
  display: block;
  width: 100px;
  height: 100px;
  margin: 120px auto 40px;
  transform: translateX(-4px);
`;

const Title = styled.strong`
  display: block;
  margin-bottom: 12px;
  color: #246cf6;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
`;

const Description = styled.p`
  font-size: 14px;
  color: #3a3b3e;
  line-height: 150%;
  white-space: pre-wrap;
  text-align: center;
  margin-bottom: 100px;
  @media ${(props) => props.theme.mobile} {
    margin-bottom: 70px;
  }
`;

const InfoTitle = styled.span`
  display: block;
  color: #246cf6;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`;
